import {store, macarons, router, api} from 'macarons'
import Board from './Board'
import Home from './components/Home'
import chloeStore from '../store'
import {ForgotPassword, ResetPassword, Confidentiality} from '@/security/components'
import { Message } from 'element-ui'
import moment from 'moment'
import {BlogList, BlogPost} from './blog'
import TradeCompetenceWidget from './components/TradeCompetenceWidget'

export default {
  install (Vue, options) {
    const actions = store._modules.root._rawModule.actions
    actions.login = (context, credentials) => {
      return api.post('security/login', credentials).then(({data}) => {
        if (data.user.roles.length < 2) {
          Message.error('Votre compte est inactif')
          throw new Error('Inactive account')
        }
        if (data.user.roles.indexOf('ROLE_CLIENT') !== -1) {
          if (!data.user.contracts.length) {
            Message.error('Votre compte n\'est lié à aucun contrat')
            throw new Error('No contract')
          }
          if (!data.user.contracts.some(c => moment(c.end) > moment())) {
            Message.error('Tous les contrats liés à votre compte sont expirés')
            throw new Error('Expired contracts')
          }
        }
        context.commit('setToken', data.value)
        context.commit('setUser', data.user)
        context.dispatch('load')
      })
    }
    actions.logout = (context) => {
      context.commit('setToken', null)
      window.location.reload()
    }
    store.hotUpdate({
      actions: actions
    })

    const token = window.localStorage.getItem('token')
    if (token) {
      store.commit('setToken', token)
    }

    store.registerModule('chloe', chloeStore)

    Vue.$menu = macarons.config.menuService

    Vue.$menu.registerDynamicMenuItems(() => {
      return store.dispatch('isGranted', {
        attribute: 'create',
        subject: 'YWC\\MacaronsBlogBundle\\Entity\\Post'
      }).then(allow => {
        return allow ? [{
          path: '/static/admin',
          title: 'Contenu Statique',
          icon: 'el-icon-fa-cubes'
        }] : []
      }).catch(() => {
        return []
      })
    })

    router.addRoutes([
      {
        name: 'board-chloe',
        path: '/boards/:id',
        component: Board,
        props: true,
        meta: { noAuth: true }
      },
      {
        name: 'confidentiality',
        path: '/confidentiality',
        meta: { noAuth: true },
        component: Confidentiality
      },
      {
        name: 'home-board',
        path: '/home',
        meta: { noAuth: true },
        component: Home
      },
      {
        name: 'static-content',
        path: '/static/admin',
        component: BlogList
      },
      {
        name: 'static-content-edit',
        path: '/static/admin/:id',
        component: BlogList,
        props: true
      }
    ])

    store.subscribe(mutation => {
      if (mutation.type === 'setUser') {
        store.dispatch('loadTheme')
        Vue.$menu.computeMenu({
          login: {
            roles: [],
            ...store.state.user
          }
        })
      }
    })

    store.commit('registerWidget', {
      label: 'Compétences',
      id: 'trade_by_competence',
      component: TradeCompetenceWidget,
      w: 12,
      h: 70
    })

    store.commit('unregisterWidget', {
      id: 'blog'
    })

    store.commit('unregisterWidget', {
      id: 'custom_graph_global_filters'
    })

    store.commit('addWidgetOverride', widget => {
      if (widget.id.substr(0, 10) === 'blog-post-') {
        widget.component = BlogPost
      }
    })

    router.addRoutes([
      {
        name: 'forgot-password',
        path: '/forgot-password',
        component: ForgotPassword,
        meta: { noAuth: true }
      },
      {
        name: 'reset-password',
        path: '/forgot-password/:token',
        component: ResetPassword,
        meta: { noAuth: true },
        props: true
      }
    ])

    router.beforeEach((to, from, next) => {
      if (from.query.filters && !to.query.filters) {
        next(`${to.fullPath}?filters=${from.query.filters}`)
        return
      }
      to.meta.noAuth = true
      if (to.name === 'login' && store.state.destination) {
        const to = Object.assign({}, store.state.destination)
        store.commit('destination', null)
        to.meta.noAuth = true
        next(to)
      } else if (to.name === 'home') {
        next('/home')
      } else if (to.name === 'board') {
        next('/boards/' + to.params.id)
      } else if (to.path === '/blog-admin') {
        next('/static/admin')
      } else if (to.name === 'board-chloe') {
        store.dispatch('getBoardAccess', to.params.id).then(access => {
          if (access) {
            next()
          } else {
            next('/home')
          }
        })
      } else {
        next()
      }
    })

    router.afterEach((to, from) => {
      store.dispatch('track', {
        url: `${window.location.href.split('#')[0]}#${to.fullPath}`,
        action: 'load-page'
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/macarons/overrides.js